import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdown, IHelper, LayoutService } from 'codex-lib';
import { BrowserName } from 'src/app/enum/browser-name';
import { RoutePages } from 'src/app/enum/route-pages';
import { AccessTokenService } from 'src/app/modules/signature/services/access-token.service';
import { BrowserUtil } from 'src/app/util/browser-util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { SharedService } from 'src/app/services/shared-service.service';
declare let BryWebExtension: any;

@Component({
  selector: 'app-bry-extension',
  templateUrl: './bry-extension.component.html',
  styleUrls: ['./bry-extension.component.scss']
})
export class BryExtensionComponent implements OnInit {

  @Output() selectChage = new EventEmitter();
  @Output() hasCertificate = new EventEmitter<boolean>();

  @Input() ssnSignatory: string = "";

  bryExtensionForm: FormGroup;
  subscriberBryExtensionDropDown: IDropdown;
  helperNoCertificatesError: IHelper;
  showAddExtension: boolean;
  isReloadExtension: boolean;
  isEnableApply: boolean;
  hasCertificateAvailable: boolean = true;
  certificates: any[];
  URLCHROME = 'https://chrome.google.com/webstore/detail/mbpaklahifpfndjiefdfjhmkefppocfm';
  URLFIREFOX = 'https://addons.mozilla.org/pt-BR/firefox/addon/assinatura-digital-navegador';
  URLSAFARI = 'https://apps.apple.com/us/app/bry-assinatura-digital/id1315721873';

  extensionBry = { certificate: '' };
  acessKey: any;
  batch: boolean;

  get subscriberBryExtension() {
 return this.bryExtensionForm.get('certificate');
}

  constructor(private _translate: TranslateService,
    public _layoutService: LayoutService,
    private _accessTokenService: AccessTokenService,
    private modalService: NgbModal) {
    this.subscriberBryExtensionDropDown = {
      items: [],
      displayText: 'value',
      placeholder: this._translate.instant('signatureModal.cloudDigital.labelCertificateText').replace(':',''),
      showSearch: false
    };

    this.helperNoCertificatesError = {
      text: this._translate.instant('signatureModal.digital.noCertificateFound'),
      hasError: true
    }
  }


  ngOnInit() {
    this.acessKey = this._accessTokenService.getAccessKey();
    this.batch = this._accessTokenService.getBatch();

    BryWebExtension.isExtensionInstalled()
  .then((installed)=>{
    if ( installed ) {
        return BryWebExtension.installComponents();

    } else {
      this.showAddExtension = true;
      this.hasCertificateAvailable = false;
    }
  })
  .then((installComponentsResponse)=>{
    this.listCertificates();
  })

    this.bryExtensionForm = new FormGroup({
      certificate: new FormControl(this.extensionBry.certificate, [
        Validators.required
      ]),
    });
  }

  installExtension() {
    if (BrowserUtil.getBrowserName() === BrowserName.CHROME) {
      window.open(this.URLCHROME);
    } else if (BrowserUtil.getBrowserName() === BrowserName.SAFARI) {
      window.open(this.URLSAFARI);
    } else {
      window.open(this.URLFIREFOX);
    }
    this.isReloadExtension = true;
  }

  reloadExtensionBry() {
    const pathLocal = `${location.protocol}//${location.host}/#/${RoutePages.Signature}?accessKey=${this.acessKey}${this.batch ? `&batch=true` : ''}`;
    const pathProd = `${location.protocol}//${location.host}${location.pathname}#/${RoutePages.Signature}?accessKey=${this.acessKey}${this.batch ? `&batch=true` : ''}`;
    this.modalService.dismissAll();
    window.location.href = environment.production ? pathProd : pathLocal;
    window.location.reload();
  }

  async listCertificates() {
    await BryWebExtension.listCertificates()
      .then(certificates => {
        this.certificates = certificates
                              .filter(certificate => (certificate.cpf || certificate.cnpj))
                              .map(certificate => ({...certificate, ssn: (certificate.cpf || certificate.cnpj)}));

        const options = [];
        this.hasCertificateAvailable = this.certificates.length > 0;

        if (this.ssnSignatory !== '') {
          this.certificates = this.filterCertificates();
          if (CPFCNPJUtil.isCNPJ(this.ssnSignatory) && !this.hasCertificateAvailable) {
            this.hasCertificate.emit(false);
          }
        }

        if (this.hasCertificateAvailable) {
          this.certificates
            .forEach(certificate => {
              options.push({ id: certificate.certId, value: certificate.name + this._translate.instant('signatureModal.digital.expireIn') + certificate.expirationDate.substring(0, 10) });
            });
        }

        this.subscriberBryExtensionDropDown = {
          items: options,
          displayText: 'value',
          placeholder: this._translate.instant('signatureModal.cloudDigital.labelCertificateText').replace(':',''),
          showSearch: false
        };

      });
  }

  filterCertificates() {
    if (!this.ssnSignatory) return;

    const isCNPJ = CPFCNPJUtil.isCNPJ(this.ssnSignatory);
    const isCPF = CPFCNPJUtil.isCPF(this.ssnSignatory);

    if (isCNPJ) {
      const hasMatchingCNPJ = this.certificates.some(cert => cert.cnpj === this.ssnSignatory);

      if (hasMatchingCNPJ) {
        this.hasCertificate.emit(true);
        return this.certificates.filter(cert => cert.cnpj === this.ssnSignatory);
      };

      this.hasCertificate.emit(false);

      return this.certificates = this.certificates.filter(cert => !cert.cnpj || cert.cnpj === this.ssnSignatory);
    }

    if (isCPF) {
      const hasMatchingCPF = this.certificates.some(cert => cert.cpf === this.ssnSignatory);

      this.certificates = this.certificates.filter(cert =>
        hasMatchingCPF
          ? cert.cpf === this.ssnSignatory && cert.cnpj === ''
          : !cert.cpf || cert.cpf === this.ssnSignatory
      );

      if(this.certificates.length === 0) {
        this.hasCertificateAvailable = false;
        this.helperNoCertificatesError = {
          text: this._translate.instant('signatureModal.digital.noCertificateFoundForCpf'),
          hasError: true
        };
      }

      return this.certificates;
    }
  }

  onDocumentSelected(value) {
    const certificate = this.certificates.find(x => x.certId === value.id);
    this.bryExtensionForm.get('certificate').setValue(certificate);

    console.log(certificate, 'Certificado Info');

    if (certificate) {
      this.isEnableApply = true;
    } else {
      this.isEnableApply = false;
    }
    this.selectChage.emit(this.isEnableApply);
  }

  public getCertificate() {
    if (this.bryExtensionForm.get('certificate') && this.bryExtensionForm.get('certificate').value) {
      return this.bryExtensionForm.get('certificate').value;
    }
    this.bryExtensionForm.get('certificate').setErrors({ invalid: true });
    return undefined;
  }

  public sign(certId, signature): Promise<any> {
    const signObject = this.objectToSign(signature);
    return BryWebExtension.sign(certId, JSON.stringify(signObject));
  }

  private objectToSign(signature) {
    const signatures = new Array();
    signature.assinaturasInicializadas.forEach(itemSignature => {
      signatures.push({
        algoritmoHash: signature.algoritmoHash,
        nonce: itemSignature.nonce,
        hashes: [itemSignature.messageDigest]
      });
    });
    return {
      formatoDadosEntrada: 'Base64',
      formatoDadosSaida: 'Base64',
      assinaturas: signatures
    };
  }
}

